import { FC } from 'react'
import { Container, Header, SpaceBetween } from '@cloudscape-design/components'

import GenericTagsNew from '../../../ControlledFormInputs/GenericTagsNew'
import StgTagsReadOnly from './StgTagsReadOnly'
import { useAccountCreationFormStore } from '../../../../stores/accounts/newAccountCreationFormStore'

const Tags: FC = () => {
	const { stgFollowUpReadOnly } = useAccountCreationFormStore()

	if (stgFollowUpReadOnly) {
		return <StgTagsReadOnly />
	}

	return (
		<SpaceBetween direction="vertical" size="l">
			<Container header={<Header variant="h3"> Add Tags </Header>}>
				<GenericTagsNew />
			</Container>
		</SpaceBetween>
	)
}

export default Tags
